// extracted by mini-css-extract-plugin
export var dropdownContainer = "_lw-0";
export var leftAlign = "_lw-4";
export var listItem = "_lw-2";
export var listItemWrapper = "_lw-1";
export var operationText = "_lw-3";